module.exports = __webpack_public_path__ + "img/drop1.c1828a97.png";